import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {ModalIdEnum, ModalState, NoticeProps} from "./types";
import {
    AuthCredentialsRequestDTO,
    ConfirmationAuthCredentialsRequestDTO,
    ConfirmationLoginResponseDTO, PatchUserRequest,
    ResendCodeRequestDTO, ResetConfirmationCodeResponseDTO,
    UserResponseDTO
} from "@app/api/generated-api";
import { initialized, RemoteData, RemoteDataStatus } from "../../../libs/remote";
import {HYDRATE} from "next-redux-wrapper";

export interface ICoreState {
    user: RemoteData<UserResponseDTO> | null;
    modals: ModalState;
    auth: RemoteData<ConfirmationLoginResponseDTO>;
    confirmStatus: RemoteDataStatus | null;
    resetConfirmStatus: RemoteData<ResetConfirmationCodeResponseDTO>;
    postRegistrationFormStatus: RemoteData<string>;
    isPolicyVisible: boolean;
    isConfirmEmailModal: string | null;
    notices: NoticeProps
}

const initialState: ICoreState = {
    user: initialized() as RemoteData<UserResponseDTO>,
    modals: initialized() as ModalState,
    auth: initialized() as RemoteData<ConfirmationLoginResponseDTO>,
    confirmStatus: null,
    resetConfirmStatus: initialized() as RemoteData<ResetConfirmationCodeResponseDTO>,
    postRegistrationFormStatus: initialized(),
    isPolicyVisible: false,
    isConfirmEmailModal: null,
    notices: {type: "error", visibility: false}
};

export const coreSlice = createSlice({
    name: "core",
    initialState,
    reducers: {
        signIn: (_state, _payload: PayloadAction<AuthCredentialsRequestDTO>) => {},
        signStatus: (state, action: PayloadAction<RemoteData<ConfirmationLoginResponseDTO>>) => {
            state.auth = action.payload;
        },

        confirmUser: (_state, _payload: PayloadAction<ConfirmationAuthCredentialsRequestDTO>) => {},
        setConfirmStatus: (state, action: PayloadAction<RemoteDataStatus>) => {
            state.confirmStatus = action.payload;
        },

        resetConfirmation: (_state, _payload: PayloadAction<ResendCodeRequestDTO>) => {},
        resetConfirmationStatus: (state, action: PayloadAction<RemoteData<ResetConfirmationCodeResponseDTO>>) => {
            state.resetConfirmStatus = action.payload;
        },

        /**
         * Отправка формы
         */
        postRegistrationForm: (_state, _action: PayloadAction<{data: {userData: PatchUserRequest, productData: FormData} }>)  => {},
        setPostRegistrationFormStatus: (state, action: PayloadAction<RemoteData<string>>) => {
            state.postRegistrationFormStatus = action.payload;
        },

        refreshAuth: (_state) => {},

        setUser: (state, action: PayloadAction<RemoteData<UserResponseDTO>>) => {
            state.user = action.payload;
        },
        fetchUser: (_state) => {},

        signOut: () => {},

        setConfirmEmail: (state, action: PayloadAction<string>) => {
            state.isConfirmEmailModal = action.payload;
        },

        changePolicyModalState: (
            state, {payload}: PayloadAction<{
                visibility?: boolean;
            }>
        ) => {
            state.isPolicyVisible = payload.visibility},

        changeNoticeState: (
            state,
            { payload }: PayloadAction<NoticeProps>,
        ) => {
            state.notices = payload
        },
        changeModalState: (
            state,
            {
                payload,
            }: PayloadAction<{
                type: ModalIdEnum;
                visibility?: boolean;
                data?: Record<string, any>;
                loading?: boolean;
            }>,
        ) => {
            state.modals[payload.type] = {
                ...state.modals[payload.type],
                type: payload.type,
                visibility: typeof payload.visibility !== "undefined" ? payload.visibility : true,
                data: {
                    ...(payload.data ? { ...state.modals[payload.type]?.data, ...payload.data } : {}),
                },
                loading: payload.loading,
            };
        },
    },
    extraReducers: {
        [HYDRATE]: (state, action) => {
            return {
                ...action.payload.core
            }
        }
    }
});

export const {
    signIn,
    setUser,
    signOut,
    changeModalState,
    fetchUser,
    refreshAuth,
    signStatus,
    confirmUser,
    setConfirmStatus,
    resetConfirmation,
    resetConfirmationStatus,
    postRegistrationForm,
    setPostRegistrationFormStatus,
    changePolicyModalState,
    setConfirmEmail,
    changeNoticeState
} = coreSlice.actions;
export default coreSlice.reducer;
